import { jsxs as l, jsx as n } from "react/jsx-runtime";
import a from "styled-components";
import s from "./Base.js";
const d = a.div`
  padding-right: 45px;
  font-size: 1.125rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  overflow-wrap: break-word;
  letter-spacing: -0.59px;
  margin-bottom: 15px;
`, p = a.div`
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  padding-bottom: 10px;
  line-height: 1.5;
  overflow-wrap: break-word;
  letter-spacing: -0.32px;
`, c = a.a`
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  padding-bottom: 10px;
  line-height: 1.5;
  overflow-wrap: break-word;
  text-decoration: underline;
  letter-spacing: -0.68px;
`;
function f(r, t) {
  return t instanceof Array ? t.map((o, e) => /* @__PURE__ */ n(r, { children: o }, `${o}_${e}`)) : /* @__PURE__ */ n(r, { children: t });
}
const m = ({
  title: r,
  value: t,
  children: o,
  titleProps: e,
  ...i
}) => /* @__PURE__ */ l(s, { type: "Error", ...i, children: [
  r && /* @__PURE__ */ n(d, { ...e, children: r }),
  o || f(c, t || "")
] }), h = ({
  title: r,
  value: t,
  children: o,
  titleProps: e,
  ...i
}) => /* @__PURE__ */ l(s, { type: "Error", ...i, children: [
  r && /* @__PURE__ */ n(d, { ...e, children: r }),
  o || f(p, t || "")
] }), b = {
  Field: m,
  Text: h
};
export {
  m as Field,
  h as Text,
  b as default
};
